import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const CaseHandle = lazy(() => import('./CaseHandleNew.jsx'))

const NewCaseHandleRoutes = [
	{
		path: '/CaseHandleNew',
		component: CaseHandle,
		auth: authRoleAccess.case_handle,
	},
]

export default NewCaseHandleRoutes

